import Component from "react-pure-render/component";
import React from "react";
import immutable from "immutable";
import PaginationItem from "./paginationItem.react";
import "./pagination.css";

export default class Pagination extends Component {
  static propTypes = {
    numberOfPages: React.PropTypes.number.isRequired,
    maxPagesDisplay: React.PropTypes.number.isRequired
  };

  static defaultProps = {
    currentPage: 1
  };

  constructor() {
    super();
  }

  next = () => {
    const { setPageAction, currentPage } = this.props;
    setPageAction(currentPage);
  };

  prev = () => {
    const { setPageAction, currentPage } = this.props;
    setPageAction(currentPage - 2);
  };

  render() {
    const { numberOfPages, currentPage, setPageAction } = this.props;

    let { maxPagesDisplay } = this.props;

    let withDots = true;
    if (maxPagesDisplay >= numberOfPages) {
      withDots = false;
    }
    if (maxPagesDisplay > numberOfPages) {
      maxPagesDisplay = numberOfPages;
    }

    let items = [];

    let i =
      currentPage - parseInt(maxPagesDisplay / 2) < 1
        ? 1
        : currentPage + parseInt(maxPagesDisplay / 2) > numberOfPages
          ? numberOfPages - maxPagesDisplay + 1
          : currentPage - parseInt(maxPagesDisplay / 2);

    const limit = i + maxPagesDisplay;

    for (i; i < limit; i++) {
      items.push(
        <PaginationItem
          key={i}
          number={i}
          action={setPageAction}
          active={i === currentPage}
        />
      );
    }

    const first = withDots ? maxPagesDisplay >
    numberOfPages ? null : currentPage - parseInt(maxPagesDisplay / 2) > 1 ? (
      <PaginationItem
        number={1}
        action={setPageAction}
        active={1 === currentPage}
      />
    ) : null : null;
    const last = withDots ? maxPagesDisplay >
    numberOfPages ? null : currentPage <
    numberOfPages - parseInt(maxPagesDisplay / 2) ? (
      <PaginationItem
        number={numberOfPages}
        action={setPageAction}
        active={numberOfPages === currentPage}
      />
    ) : null : null;

    if (first !== null) {
      items.shift();
    }

    if (last !== null) {
      items.pop();
    }

    const prev = (
      <div
        className={currentPage !== 1 ? "prev item" : "prev item disabled"}
        onClick={currentPage !== 1 ? this.prev : null}
      >
        <div className="arrow" />
      </div>
    );

    const next = (
      <div
        className={
          currentPage !== numberOfPages ? "next item" : "next item disabled"
        }
        onClick={currentPage !== numberOfPages ? this.next : null}
      >
        <div className="arrow" />
      </div>
    );

    if (numberOfPages > 1) {
      return (
        <div className="row center-xs middle-xs pagination-wrapper">
          {prev}
          {first}
          {first !== null ? <div className="dots">...</div> : null}
          {items}
          {last !== null ? <div className="dots">...</div> : null}
          {last}
          {next}
        </div>
      );
    } else {
      return <div className="row center-xs middle-xs pagination-wrapper" />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/pagination/pagination.react.js